import { Component, OnDestroy, OnInit } from "@angular/core"
import { AddOnViewService } from "../services/add-on-view.service"
import { ABOUT_ROUTES, AboutRoute, AboutService } from "../services/about.service"
import { IWindowResizeEvent, WindowSizeService } from "../services/window-size.service"
import { map, takeUntil } from "rxjs/operators"
import { Observable, ReplaySubject } from "rxjs"

@Component({
    templateUrl: "./about.component.html",
    styleUrls: ["./about.component.scss"],
})
export class AboutComponent implements OnInit, OnDestroy {
    isAddonView: boolean = false
    aboutRoutes: AboutRoute[] = [...ABOUT_ROUTES]
    isDesktop$: Observable<boolean>
    destroyed$: ReplaySubject<boolean> = new ReplaySubject(1)

    constructor(
        private addOnService: AddOnViewService,
        private aboutService: AboutService,
        public windowSize: WindowSizeService
    ) {}

    ngOnInit() {
        this.isAddonView = this.addOnService.isAddonView
        this.aboutRoutes = this.aboutService.prefixRoutes(this.aboutRoutes, "/about/")
        this.isDesktop$ = this.windowSize.resize.pipe(
            takeUntil(this.destroyed$),
            map((data: IWindowResizeEvent) => !data.isTablet)
        )
    }

    getGTMClass(routeTitle: string): string {
        return "gtm-" + routeTitle.toLowerCase().replace(" &", "").replace(/\s/g, "-") + "-link"
    }

    ngOnDestroy(): void {
        this.destroyed$.next(true)
        this.destroyed$.complete()
    }
}
